module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware/~/core-js/library/modules/$.add-to-unscopables.js
// module id = 1892
// module chunks = 0